// https://gist.github.com/philmerrell/d65655ef73a5b3be863491b19b3902ba

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { soundSoundIdURL } from '../powernova/powernova-value/powernova-value.model';

@Injectable()
export class AudioService {

    public audio: HTMLAudioElement;
    public percentElapsed$: BehaviorSubject<string> = new BehaviorSubject('0%');
    public playerStatus$: BehaviorSubject<string> = new BehaviorSubject('paused');
    public src: string;

    // TODO: remove once places its used are NgFactor
    getUrlForSoundId(): string {
        return soundSoundIdURL;
    }

    setAudio(audio): void {
        this.audio = audio;
        //audio.preload = 'none';
        this.attachListeners();
    }

    private attachListeners(): void {
        this.audio.addEventListener('timeupdate', this.calculateTime, false);
        this.audio.addEventListener('playing', this.setPlayerStatus, false);
        this.audio.addEventListener('pause', this.setPlayerStatus, false);
        this.audio.addEventListener('ended', this.setPlayerStatus, false);
    }

    private calculateTime = evt => {
        const currentTime = this.audio.currentTime;
        const duration = this.audio.duration;
        this.setPercentElapsed(duration, currentTime);
    };

    private setPlayerStatus = evt => {
        switch (evt.type) {
            case 'playing':
                this.playerStatus$.next('playing');
                break;
            case 'pause':
                this.playerStatus$.next('paused');
                break;
            case 'ended':
                this.playerStatus$.next('ended');
                break;
            default:
                this.playerStatus$.next('paused');
                break;
        }
    };

    public playAudio(): void {
        this.audio.play();
    }

    public pauseAudio(): void {
        this.audio.pause();
    }

    public stopAudio(): void {
        this.audio.pause();
        this.audio.currentTime = 0;
        this.playerStatus$.next('paused');
    }

    /**
     * This method takes the track's "duration" and "currentTime" properties to calculate the percent of time elapsed.
     * This is valuable for setting the position of a range input. It is called from the calculateTime method.
     */
    private setPercentElapsed(duration: number, currentTime: number): void {
        const max = 80;
        const elapsed = Math.floor((100 / duration) * currentTime);
        this.percentElapsed$.next(`${elapsed > max ? max : elapsed}%` || '0%');
    }

    /**
     * This method returns an Observable whose value is the current status of the player.
     * This is useful inside your component to key off certain values, for example:
     *   - Show pause button when player status is 'playing'
     *   - Show play button when player status is 'paused'
     *   - Show loading indicator when player status is 'loading'
     *
     * See the setPlayer method for values.
     */
    public getPlayerStatus(): Observable<string> {
        return this.playerStatus$.asObservable();
    }

    public getAudio(): any {
        return this.audio;
    }

    /**
     * Convenience method to toggle the audio between playing and paused
     */
    public toggleAudio(): void {
        (this.audio.paused) ? this.audio.play() : this.audio.pause();
    }
}
